module.exports = __webpack_public_path__ + "img/stones-2.ca5cb43.png";